let dicMap = window.sessionStorage;
// let obj = {};
// let LODOP;
import request from "@/utils/request";
export function dictionaries(key) {
  return request({
    url: "/dict/selectByZdlb",
    method: "get",
    params: {
      dictAbbr: key
    }
  });
}

function diction(resolve, reject, key, val) {
  dictionaries(key)
    .then(res => {
      let data = res.data;
      if (data.success) {
        let arr = data.msg.data.map(i => {
          i.label = i.codeName;
          i.value = i.codeValue;
          return i;
        });
        dicMap.setItem(key, JSON.stringify(arr));
        if (val) {
          let res;
          res = arr.filter(i => {
            return i.value == val;
          });
          if (res.length) {
            res = res[0].label;
          } else {
            res = val;
          }
          resolve(res);
        } else {
          resolve(arr);
        }
      } else {
        reject();
      }
    })
    .catch(() => {
      console.log("失败'");
    });
}

export function doCreate(key) {
  let res;
  if (key === null || key === undefined) return [];
  if (dicMap.getItem(key)) {
    res = JSON.parse(dicMap.getItem(key));
  } else {
    dictionaries(key).then(data => {
      let data1 = data.data;
      let arr = data1.msg.data;
      if (data.success) {
        dicMap.setItem(key, JSON.stringify(arr));
        doCreate(key);
      }
    });
  }
  // return new Promise((resolve, reject) => {
  //   if (dicMap.getItem(key)) {
  //     resolve(JSON.parse(dicMap.getItem(key)));
  //   } else {
  //     diction(resolve, reject, key);
  //   }
  // });
  return res;
}

export function getDicTab(key, val) {
  let res;
  if (val === null || val === undefined) return "";
  if (dicMap.getItem(key)) {
    res = JSON.parse(dicMap.getItem(key)).filter(i => {
      return i.value == val;
    });
    if (res.length) {
      res = res[0].label;
    } else {
      res = val;
    }
    return res;
  }
  diction(key).then(() => {
    getDicTab(key, val);
  });
}

export function paymoney(money) {
  let reg = /^(0|[1-9][0-9]*)+(\.[0-9]{1,2})?$/;
  if (money && reg.test(Number(money))) {
    money = String(money);
    var left = money.split(".")[0],
      right = money.split(".")[1];
    right = right
      ? right.length >= 2
        ? "." + right.substr(0, 2)
        : "." + right + "0"
      : ".00";
    var temp = left
      .split("")
      .reverse()
      .join("")
      .match(/(\d{1,3})/g);
    return (
      (Number(money) < 0 ? "-" : "") +
      temp
        .join(",")
        .split("")
        .reverse()
        .join("") +
      right
    );
  } else if (money === 0) {
    //注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return "0.00";
  }
  return "0.00";
}

//打印
//打印
export function printExcel(id) {
  // let Print = document.getElementById(id);
  // let arr = Array.prototype.slice.call(Print.getElementsByClassName('el-table__body')[0].getElementsByClassName('cell'));
  // let tab = Array.prototype.slice.call(Print.querySelectorAll('table'));

  // arr.map(i=>{
  //     i.setAttribute("style","width:100%!important");
  // })
  // tab.map(j=>{
  //   j.setAttribute("style","width:100%!important");
  // })
  // let newContent = Print.innerHTML;
  // let oldContent = document.body.innerHTML;
  // document.body.innerHTML = newContent;
  // window.print();
  // document.body.innerHTML = oldContent;
  // window.location.reload();
  // return false
  let printStr =
    "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'></head>";
  const tabStyle = `<style>
  table{width:100%;display:table-cell!important;box-sizing:border-box;}
  .el-table__header,.el-table__body,.el-table__footer{width:100%!important;border-collapse: collapse;text-align:center;}
  table,table tr th, table tr td { border:1px solid #ddd;color:#606266;}
  table tr th,table tr td{padding:4mm 0mm }
  .el-table__body, tr td .cell{width:100%!important}
  .el-table th.gutter{display: none;}
  .el-table colgroup.gutter{display: none;}
  table thead tr:nth-child(1) th:nth-child(1){
    width:4%;
  }
  table thead tr:nth-child(1) th:nth-child(2){
    width:11%;
  }
  table thead tr:nth-child(1) th:nth-child(3){
    width:9%;
  }
  table thead tr:nth-child(1) th:nth-child(4){
    width:9%;
  }
  table thead tr:nth-child(1) th:nth-child(5){
    width:15%;
  }
  table thead tr:nth-child(1) th:nth-child(6){
    width:39%;
  }
  table thead tr:nth-child(1) th:nth-child(7){
    width:13%;
  }
  table thead tr:nth-child(2) th:nth-child(1){
    width:13%;
  }
  table thead tr:nth-child(2) th:nth-child(2){
    width:13%;
  }
  table thead tr:nth-child(2) th:nth-child(3){
    width:13%;
  }
  table tbody tr td:nth-child(1){
    width:4%;
  }
  table tbody tr td:nth-child(2){
    width:11%
  }
  table tbody tr td:nth-child(3){
    width:9%
  }
  table tbody tr td:nth-child(4){
    width:9%
  }
  table tbody tr td:nth-child(5){
    width:15%
  }
  table tbody tr td:nth-child(6){
    width:13%
  }
  table tbody tr td:nth-child(7){
    width:13%
  }
  table tbody tr td:nth-child(8){
    width:13%
  }
  table tbody tr td:nth-child(9){
    width:13%
  }
  </style><body>`;
  let content = "";
  let str = document.getElementById(id).innerHTML;
  content = content + str;
  printStr = printStr + tabStyle + content + "</body></html>";
  let pwin = window.open("_blank");
  pwin.document.write(printStr);
  pwin.document.close();
  pwin.focus();
  setTimeout(() => {
    pwin.print();
    pwin.close();
  }, 500);
}
//导出
import FileSaver from "file-saver";
import XLSX from "xlsx";
export function exportExcel(id, name) {
  // var arr = Array.prototype.slice.call(document.getElementsByClassName('has-gutter')[1].getElementsByClassName('is-leaf'));
  // arr.map(i => {
  //   i.setAttribute("rowspan", "1");
  // })
  /* generate workbook object from table */
  var wb = XLSX.utils.table_to_book(document.querySelector("#" + id));
  /* get binary string as output */
  var wbout = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: true,
    type: "array"
  });
  try {
    FileSaver.saveAs(
      new Blob([wbout], {
        type: "application/octet-stream"
      }),
      name + ".xlsx"
    );
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, wbout);
  }
  return wbout;
}
// import { getLodop } from "./LodopFuncs.js";
//lodop打印编辑
// export function printPzBj(row) {//其他模块没有引用先注释
//   let skrq = row.skrq.split("-");
//   LODOP = getLodop();
//   LODOP.PRINT_INITA(0, 0, 724, 335, "打印凭证");
//   LODOP.SET_PRINT_PAGESIZE(2, 0, 0, "");
//   LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED", 1); //横向时的正向显示
//   LODOP.ADD_PRINT_SETUP_BKIMG("<img border='0' src='/images/pint.jpg'>");
//   LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "190.5mm");
//   LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "88.11mm");
//   LODOP.SET_SHOW_MODE("BKIMG_IN_PREVIEW", true);
//   LODOP.ADD_PRINT_TEXT("30.4mm", "61.65mm", 216, 25, row.jkdw);
//   LODOP.ADD_PRINT_TEXT("18.49mm", "132.03mm", 27, 25, skrq[2]);
//   LODOP.ADD_PRINT_TEXT("18.76mm", "121.97mm", 27, 25, skrq[1]);
//   LODOP.ADD_PRINT_TEXT("18.76mm", "107.69mm", 34, 25, skrq[0]);
//   LODOP.ADD_PRINT_TEXT("51.83mm", "135.73mm", 116, 25, row.je);
//   LODOP.ADD_PRINT_TEXT("51.83mm", "65.09mm", 216, 25, row.jeDx);
//   LODOP.ADD_PRINT_TEXT("40.98mm", "55.3mm", 423, 25, row.sknr);
//   LODOP.ADD_PRINT_TEXT("73.26mm", "61.38mm", 169, 25, row.skdw);
//   LODOP.ADD_PRINT_TEXT("73.26mm", "134.14mm", 83, 25, row.skr);
//   LODOP.ADD_PRINT_TEXT(
//     "30.93mm",
//     "143.14mm",
//     103,
//     25,
//     getDicTab("jsfs", row.jsfs)
//   );
//   // LODOP.ADD_PRINT_TEXT("12.67mm", "144.46mm", 125, 25, row.pzh);
//   LODOP.SET_SHOW_MODE("BKIMG_IN_PREVIEW", 1); //注："BKIMG_IN_PREVIEW"-预览包含背景图 "BKIMG_IN_FIRSTPAGE"- 仅首页包含背景图
//   if (LODOP.CVERSION) {
//     CLODOP.On_Return = function(TaskID, Value) {
//       if (Value) {
//         alert("发送成功");
//       } else alert("发送取消");
//     };
//     LODOP.PRINT_DESIGN();
//     return;
//   }

//   // LODOP.PRINT()
// }
//lodop打印
// export function printPz(row) { //其他模块没有引用先注释
//   let skrq = row.skrq.split("-");
//   LODOP = getLodop();
//   LODOP.PRINT_INITA(0, 0, 724, 335, "打印凭证");
//   LODOP.SET_PRINT_PAGESIZE(2, 0, 0, "");
//   LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED", 1); //横向时的正向显示
//   LODOP.ADD_PRINT_SETUP_BKIMG("<img border='0' src='/images/pint.jpg'>");
//   LODOP.SET_SHOW_MODE("BKIMG_WIDTH", "190.5mm");
//   LODOP.SET_SHOW_MODE("BKIMG_HEIGHT", "88.11mm");
//   LODOP.SET_SHOW_MODE("BKIMG_IN_PREVIEW", true);
//   LODOP.ADD_PRINT_TEXT("30.4mm", "61.65mm", 216, 25, row.jkdw);
//   LODOP.ADD_PRINT_TEXT("18.49mm", "132.03mm", 27, 25, skrq[2]);
//   LODOP.ADD_PRINT_TEXT("18.76mm", "121.97mm", 27, 25, skrq[1]);
//   LODOP.ADD_PRINT_TEXT("18.76mm", "107.69mm", 34, 25, skrq[0]);
//   LODOP.ADD_PRINT_TEXT("51.83mm", "135.73mm", 116, 25, row.je);
//   LODOP.ADD_PRINT_TEXT("51.83mm", "65.09mm", 216, 25, row.jeDx);
//   LODOP.ADD_PRINT_TEXT("40.98mm", "55.3mm", 423, 25, row.sknr);
//   LODOP.ADD_PRINT_TEXT("73.26mm", "61.38mm", 169, 25, row.skdw);
//   LODOP.ADD_PRINT_TEXT("73.26mm", "134.14mm", 83, 25, row.skr);
//   LODOP.ADD_PRINT_TEXT(
//     "30.93mm",
//     "143.14mm",
//     103,
//     25,
//     getDicTab("jsfs", row.jsfs)
//   );
//   // LODOP.ADD_PRINT_TEXT("12.67mm", "144.46mm", 125, 25, row.pzh);
//   LODOP.SET_SHOW_MODE("BKIMG_IN_PREVIEW", 1); //注："BKIMG_IN_PREVIEW"-预览包含背景图 "BKIMG_IN_FIRSTPAGE"- 仅首页包含背景图
//   // LODOP.PRINT_DESIGN();
//   // LODOP.PRINTA();
//   //云打印C-Lodop返回结果用回调函数:
//   if (LODOP.CVERSION) {
//     CLODOP.On_Return = function(TaskID, Value) {
//       if (Value) {
//         return true;
//       }
//       return false;
//     };
//     LODOP.PRINTA();
//     return;
//   }
//   // if (LODOP.PRINTA()) {
//   //   alert("已发出实际打印命令！");
//   // } else {
//   //   alert("放弃打印！");
//   // }
// }

//数字金额转化为大写
export function moneyText(money) {
  let list = money.split(".");
  if (list.length > 2) {
    return "";
  }
  let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  let unit = ["亿", "万", "仟", "佰", "拾", ""];
  let text = getText(String(Number(list[0]))) + "元";
  if (list.length == 2 && list[1].substring(0, 2) != "00") {
    if (list[1].charAt(0) != "0") {
      text += digit[list[1].charAt(0)] + "角";
    }
    if (list[1].charAt(1) != "0") {
      text += digit[list[1].charAt(1)] + "分";
    }
  } else {
    text += "整";
  }
  return text;

  function getText(m) {
    let str = "";
    let start = 0;
    let num = [9, 5, 4, 3, 2, 1];
    if (m.length == 1) {
      return digit[m];
    }
    num.map((n, i) => {
      if (m.length >= n) {
        let dig = m.substring(start, m.length - n + 1);
        str += getText(dig) + unit[Number(dig) ? i : 5];
        start += m.length - n + 1 - start;
      }
    });
    return str;
  }
}
